<template>
  <div v-parallax-fit="parallax" class="action">
    <img src="/themes/rise-theme/dist/images/estate/character-view/holly/22_MHActioLogo_1@2x.png" alt="">
  </div>
</template>

<script>

export default {
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 17500,
          end: 18200,
          fromStyle: { transform: 'translateY(-350%) translateX(60%)', marginTop: '0px' },
          toStyle: { transform: 'translateY(50%) translateX(0%)', marginTop: '10px' },
          easing: 'linear'
        },
        {
          start: 18800,
          end: 19500,
          fromStyle: { transform: 'translateY(50%) translateX(0%)', marginTop: '0px' },
          toStyle: { transform: 'translateY(430%) translateX(-100%)', marginTop: '0px' },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/holly/evidence/12.png',
          url: 'https://mhaction.org',
          link_title: {
			'en': "MHAction",
			'es': "MHAction"
		  },
        }
      ],
      text: {
		'en': 'Through a robust online to offline organizing program, MHAction staff recruit, train, and coach manufactured home residents to be  leaders and organizers in their communities.',
		'es': 'A través de un sólido programa de organización en línea y fuera de línea, el personal de MHAction recluta, capacita y capacita a los residentes de casas prefabricadas para que sean líderes y organizadores en sus comunidades.'
	  }
    };
    const text = {
		'en': "MHAction is a growing national movement of manufactured home community residents who organize their neighbors, build campaigns to protect the affordability and quality of their communities, and fight to advance racial, economic, and gender justice.",
		'es': 'MHAction es un movimiento nacional creciente de residentes de comunidades de casas prefabricadas que organizan a sus vecinos, crean campañas para proteger la asequibilidad y la calidad de sus comunidades y luchan para promover la justicia racial, económica y de género.'
	};

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.marginTop == '10px') {
          this.$evidence.value = JSON.stringify(evidence);
          this.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('.action'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  }
}
</script>

<style lang="scss" scoped>
.action {
  position: absolute;
  top: 15%;
  right: 10%;
  max-width: 400px;
  transition: all 0.1s linear;
}

@media screen and (max-width: 1024px) {
  .action {
    max-width: 300px;
  }
}

@media screen and (max-width: 650px) {
  .action {
    max-width: 200px;
  }
}
</style>
